function lhm_playHeaderVideo(video) {
    video.play().catch(() => {
        // Autoplay can still be blocked by the browser (e.g. no user
        // interaction yet on some mobile browsers) - poster stays
        // visible in that case, same as it would have before.
    });
}

function lhm_deferHeaderVideos(selector = '.headerVideoPlayer') {
    document.querySelectorAll(selector).forEach((video) => {
        // .mobilePortrait/.desktop variants both exist in the DOM at once
        // (CSS hides whichever doesn't match the current breakpoint) -
        // loading/playing both simultaneously can starve the one that's
        // actually visible, so skip anything currently display:none.
        if (video.offsetParent === null) {
            return;
        }

        const source = video.querySelector('source[data-src]');

        if (!source) {
            // Already promoted on an earlier switch - some browsers pause a
            // video once its container gets display:none (season switch
            // toggling .headerBannerMedia-inactive), and .load()/.play() are
            // otherwise only ever called once here, so switching back to an
            // already-promoted video needs an explicit re-play, not just a
            // data-src check.
            lhm_playHeaderVideo(video);
            return;
        }

        source.src = source.getAttribute('data-src');
        source.removeAttribute('data-src');
        video.load();
        lhm_playHeaderVideo(video);
    });
}

window.lhm_deferHeaderVideos = lhm_deferHeaderVideos;

// The header banner dual-renders both seasons' media (so switching is
// instant/CSS-only and the video element never gets destroyed) but only the
// currently active season's video should be eagerly promoted/played on load -
// the other season's video stays deferred until it's actually switched to.
function lhm_getActiveHeaderVideoSelector() {
    const activeSeason = document.body.classList.contains('season-winter') ? 'winter' : 'sommer';
    return '.headerBannerMedia-' + activeSeason + ' .headerVideoPlayer, .headerBannerMedia:not(.headerBannerMedia-sommer):not(.headerBannerMedia-winter) .headerVideoPlayer';
}

window.lhm_getActiveHeaderVideoSelector = lhm_getActiveHeaderVideoSelector;

function lhm_setViewportHeight() {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', vh + 'px');
}

// Measures this page's actual scrollbar width (0 if the page is too short to
// scroll) instead of forcing the scrollbar to always show or permanently
// reserving gutter space - CSS that needs to compensate for the scrollbar
// (calc(100% - var(--scrollbar-width))) then adapts per-page automatically.
function lhm_setScrollbarWidth() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`);
    document.documentElement.style.setProperty('--scrollbar-width-lockscroll', `${scrollbarWidth}px`);
}

function lhm_initHeaderScrollDown() {
    document.querySelectorAll('.headerBannerScrollDown').forEach((button) => {
        button.addEventListener('click', () => {
            const target = document.querySelector(button.dataset.scrollTarget);
            if (!target) {
                return;
            }
            target.scrollIntoView({ behavior: 'smooth' });
        });
    });
}

window.addEventListener('load', () => {
    lhm_deferHeaderVideos(lhm_getActiveHeaderVideoSelector());
    lhm_setViewportHeight();
    lhm_setScrollbarWidth();
    lhm_initHeaderScrollDown();
});

window.addEventListener('resize', lhm_setViewportHeight);

let lhm_headerVideoResizeTimeout = null;
window.addEventListener('resize', () => {
    clearTimeout(lhm_headerVideoResizeTimeout);
    lhm_headerVideoResizeTimeout = setTimeout(() => {
        lhm_deferHeaderVideos(lhm_getActiveHeaderVideoSelector());
    }, 150);
});
